/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";
import {
  BsCurrencyExchange,
  BsDoorOpen,
  BsFileEarmarkPdfFill,
  BsGearWideConnected,
  BsReverseLayoutTextWindowReverse,
  BsWalletFill,
} from "react-icons/bs";
import { FaMoneyBillAlt, FaUserAlt } from "react-icons/fa";
import { FcMoneyTransfer, FcRules, FcWorkflow } from "react-icons/fc";
import { FiAlertTriangle } from "react-icons/fi";
import { GiSandsOfTime } from "react-icons/gi";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { ImUpload, ImUsers } from "react-icons/im";
import { IoIosCreate } from "react-icons/io";
import {
  MdAccountBalanceWallet,
  MdOutlineAccountBalance,
  MdOutlineHistory,
  MdPayment,
  MdPending,
  MdRequestPage,
  MdSettings,
  MdSupportAgent,
} from "react-icons/md";
import { SiKnown } from "react-icons/si";
import { VscVerified } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import cashSvg from "../../assets/images/svgs/cash.svg";
import document from "../../assets/images/svgs/document.svg";
import peopleSvg from "../../assets/images/svgs/people.svg";
import reportSvg from "../../assets/images/svgs/report.svg";
import transferSvg from "../../assets/images/svgs/transfer.svg";
import walletSvg from "../../assets/images/svgs/wallet.svg";
import {
  menuInitialStatus,
  menuType,
  userTypes,
} from "../../utils/helpers/constants";
import { getBaseUrl } from "../../utils/services/baseUrl";

function LoanMenu({ active, menu, domainBrand, profile, userModules }) {
  const dropDownInitState = menuInitialStatus;
  const [dropDownStatus, updateDropDownStatus] = useState(dropDownInitState);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const reboundNav = (event, id) => {
    event.preventDefault();
    expandMenu(id);
  };

  const expandMenu = (idName) => {
    const dropDownData = { ...dropDownInitState, [idName]: true };
    updateDropDownStatus(dropDownData);
  };

  const domainUrl = getBaseUrl();

  useEffect(() => {
    expandMenu(menu);
  }, [menu]);

  return (
    <>
      {/* MANAGER */}
      {/* REPORTS */}
      {/* {profile.userType === userTypes.MANAGER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp; Loan Account Performance
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* MANAGEMENT */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["m_trading_partners"]
                    : "Partners/Agents/Branches"}
                </NavLink>
              </li>
            )}
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_APPROVEDISAPPROVE_P_36761235"]
                    : "Approve/Disapprove Agents"}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
      )} */}

      {/* EMPLOYEES */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["WO_EMPLOYEE_-1048133672"]
              : "Employees"}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                    : "Approve/Disapprove Cashier Profiles"}
                </NavLink>
              </li>
            )}
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["para_pay_center_admins"]
                    : "Administrators"}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
      )} */}

      {/* IMPORT DATA FROM FILE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["m_load_data_from_file"]
              : "Import Data From File"}
            &nbsp;
          </NavLink>
        </li>
      )} */}

      {/* COMPLIANCE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
            exact
            to="/compliance"
            className={menu === menuType.COMPLIANCE ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus ? dictionary["m_compliance"] : "Compliance"} &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.COMPLIANCE]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/kyc-rules" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["KYCKNOW_YOUR_CUSTOM_723094592"]
                  : "KYC Rules"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/awaiting-verification" className="slide-item">
                <VscVerified color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_AWAITING_VERIFICATIO_4608421"]
                  : "Awaiting Verification"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CRM */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.CRM)}
            exact
            to="/crm"
            className={menu === menuType.CRM ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus ? dictionary["WO_CR_-560706472"] : "CRM"} &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.CRM] ? "submenu-dropdown" : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Profile
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; List Loan
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; List Loan
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Restructure Payment
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Approval Loan Request
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Issue Unrequest Loan
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* PRODUCTS */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
            exact
            to="/compliance"
            className={menu === menuType.COMPLIANCE ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus
              ? dictionary["WO_PRODUCT_-541446518"]
              : "Products"}{" "}
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.COMPLIANCE]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/kyc-rules" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp; Add New Interest Rate
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/kyc-rules" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp; Add New Loan Products
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/kyc-rules" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp; Approval Loan Request
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CROSS BORDER */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.CROSSBORDER)}
            exact
            to="/security"
            className={menu === menuType.CROSSBORDER ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Cross Border
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.CROSSBORDER]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp; Setup
              </NavLink>
            </li>
            <li>
              <NavLink to="/" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp; Tax
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-creation"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_BANK_FIELD_951387132"]
                  : "Bank Fields"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* SETTINGS */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SETTINGS)}
            exact
            to="/settings"
            className={menu === menuType.SETTINGS ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Settings
            &nbsp;
           
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SETTINGS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "workflow" ? "active" : ""}>
              <NavLink to="/settings/workflow" className="slide-item">
                <FcWorkflow color={"#6259CA"} fontSize={20} fill={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_WORKFLO_-434837466"]
                  : "Workflow"}
              </NavLink>
            </li>

            <li className={active === "remittance-settings" ? "active" : ""}>
              <NavLink
                to="/settings/remittance-fee-settings"
                className="slide-item"
              >
                <BsGearWideConnected
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_REMITTANCE_SETTING_-1350168954"]
                  : "Remittance Settings"}
              </NavLink>
            </li>

            <li className={active === "brand" ? "active" : ""}>
              <NavLink to="/settings/brand-settings" className="slide-item">
                <BsGearWideConnected
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["m_visual_settings"]
                  : "Brand Settings"}
              </NavLink>
            </li>

            <li className={active === "email" ? "active" : ""}>
              <NavLink to="/settings/email-settings" className="slide-item">
                <AiOutlineMail
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EMAIL_SETTING_2052406034"]
                  : "Email Settings"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* FEE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SECURITY)}
            exact
            to="/"
            className={menu === menuType.SECURITY ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp;
            {languageStatus ? dictionary["m_set_remittance_commission"] : "Fee"}
            &nbsp;
           
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SECURITY]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                Set up
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                Fee
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* SECURITY */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SECURITY)}
            exact
            to="/security"
            className={menu === menuType.SECURITY ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Security
            &nbsp;
            
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SECURITY]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_IP_ADDRESS_RESTRICTI_-421114094"]
                  : "IP Whitelisting"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_TWO_FACTOR_AUTHENTIC_-1180686726"]
                  : "Two Factor Authentication"}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-creation"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ENABLE_STRONG_CUSTOM_-1835724157"]
                  : "Strong Customer Authentication"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/account-creation" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_PASSWORD_POLIC_-261182106"]
                  : "Password Policy"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/account-creation" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ENABLE_TRANSACTION_P_1460895606"]
                  : "Enable Transaction Pin"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CASHIER */}
      {profile.userType === userTypes.CASHIER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.CRM)}
            exact
            to="/crm"
            className={menu === menuType.CRM ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus ? dictionary["WO_CR_-560706472"] : "CRM"} &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.CRM] ? "submenu-dropdown" : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Profile
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; List Loan
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; View
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Restructure Payment
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Approval Loan Request
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Issue Unrequest Loan
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Apply For Loan
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp; Repay Loan
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* CUSTOMER */}
      {/* {profile.userType === userTypes.CUSTOMER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp; View Loan Payments
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp; View Loan Repayment Plan
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* TRANSACTION */}
      {/* {profile.userType === userTypes.CUSTOMER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["para_transaction"]
              : "Transaction"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <MdAccountBalanceWallet fontSize={25} color={"#6259CA"} />
                &nbsp; Apply for Loan
              </NavLink>
            </li>
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <MdAccountBalanceWallet fontSize={25} color={"#6259CA"} />
                &nbsp; Repay Loan
              </NavLink>
            </li>
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <MdAccountBalanceWallet fontSize={25} color={"#6259CA"} />
                &nbsp; List available Loan Products
              </NavLink>
            </li>
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <MdAccountBalanceWallet fontSize={25} color={"#6259CA"} />
                &nbsp; List my Loan Products
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* BRANCH_ADMIN */}
      {profile.userType === userTypes.BRANCH_ADMIN && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_EMPLOYEE_-1048133672"]
                    : "Employees"}
                </NavLink>
              </li>
            )}
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                    : "Approve/Disapprove Cashier Profiles"}
                </NavLink>
              </li>
            )}
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["m_load_data_from_file"]
                    : "Import Data From File"}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
      )}

      {profile.userType === userTypes.BRANCH_ADMIN ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            {domainUrl === "https://test.moneytransferapplication.uk" && (
              <li className={active === "reports" ? "active" : ""}>
                <NavLink
                  exact
                  to="/report/my-transactions"
                  className="slide-item"
                >
                  <BiTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {/* {languageStatus
                    ? dictionary["l_my_transactions"]
                    : "Payin"} */}
                  Branch Ledger Activities
                </NavLink>
              </li>
            )}
          </ul>
        </li>
      ) : (
        ""
      )}
    </>
  );
}

export default LoanMenu;
